export const MPTOwnerDisplay = props => {
  let owner = null
  props.owner === "Lenieme" || props.owner === "" ? owner = null : owner = props.owner

  const ownerTitle = owner !== null && owner !== undefined ? `${owner}` : ""
  const ownerDescription = owner !== null && owner !== undefined ? `This NFT is the property of` : ""

  const ownerAddress = props.ownerAddress

  let ownerUrl = ""

  ownerAddress !== "" && owner !== null && owner !== undefined ? ownerUrl = `https://opensea.io/${ownerAddress}` : ownerUrl = props.nftPath
  
  return (
    <div className="ownerContainer">
      <div className="ownerDescription">
        {ownerDescription}
      </div>
      <a className="ownerLink pointerHover" href={ownerUrl} target="_blank" rel="noreferrer">
        <div className="ownerTitle">
          {ownerTitle}
        </div>
      </a>
    </div>
  )
}